export default {
  bankpay: {
    title: "Bank statements, payment documents",
    bankStat: {
      modal: {
        title: "Bank statement"
      },
      form: {
        datebank: {
          title: "Bank date"
        },
        quantity: {
          title: "Amount of payments"
        },
        summa: {
          title: "Total of payments"
        },
        accountid: {
          title: "Account-recipient"
        }
      }
    },
    payDocEdit: {
      modal: {
        title: "Payment document"
      },
      form: {
        paymentStatus: {
          title: "Payment"
        },
        paynumber: {
          title: "№ of document"
        },
        okpo: {
          title: "OKPO"
        },
        datepay: {
          title: "Date of payment"
        },
        codefirme: {
          title: "Sender"
        },
        summa: {
          title: "Total"
        },
        astatus: {
          title: "total includes commission fee"
        },
        kindpay: {
          title: "Payment method"
        },
        mess: {
          title: "Comment"
        }
      }
    },
    uploadFiles: {
      modal: {
        title: "File upload"
      },
      form: {
        encoding: {
          title: "Encoding"
        },
        uploadfile: {
          title: "Files to upload"
        }
      }
    },
    confirm: {
      modal: {
        title: "Sender organization"
      },
      form: {
        info: {
          title:
            "Select the organization that sent the payment with the specified payment details"
        },
        sender: {
          title: "Sender"
        },
        mfo: {
          title: "BIC"
        },
        rcount: {
          title: "Checking account"
        },
        summa: {
          title: "Total of payment"
        },
        okpo: {
          title: "OKPO"
        },
        codefirme: {
          title: "Organization"
        },
        alienpay: {
          title: "Foreign payment"
        },
        saveforsender: {
          title: "Remember selection for this sender"
        }
      }
    },
    bankStatColumn: {
      headers: {
        bankStatement: "Bank statement",
        postRecording: "Record entry"
      }
    },
    payDocColumn: {
      headers: {
        payDoc: "Payment documents",
        postRecording: "Record entry"
      }
    },
    deleteBankStat: {
      title: "Deletion",
      message: "Delete selected bank statement and all its payments?"
    },
    deleteModal: {
      title: "Deletion",
      message: "Delete entry?"
    },
    checkImport: {
      rcount: "account"
    },
    bankStatPostingConfirm: {
      title: "Deliver",
      message:
        "Finish work with the bank statement and allow to connect the specified payments with packs?"
    }
  }
};
